// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headerIcon[data-v-63d84ed1] {\n  background-color: #0302132d;\n  padding: .2%;\n}\n\n/* Additional custom styles if needed */\n", ""]);
// Exports
module.exports = exports;
